<template>
  <section  id="uti-panel-selected" class="selected-test-preview">
    <div class="test-panel-name">
      <p class="name">Selected Panels</p>
      <p class="viewPanel" @click="showUTITests">{{ this.UTIPanels }}</p>
    </div>

    <div class="default-modal" v-if="utiTestsPopup">
      <el-dialog v-model="utiTestsPopup">
        <div class="dialog-header">
          <span class="header-part">UTI</span>
          <el-button size="medium" class="el-white" type="info" plain @click="utiTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li class="toxicology-text-panels" v-for="(category, index) of getCaseCategoryData()" :key="index">
              <h3 class="test-group-title">
                {{ category.panel_title }}
              </h3>
              <ul class="check-list-woundpanel">
                <li v-for="(item, index) of getCategoryWiseTestsData(
                  'UTI',
                  category.panel_id,
                  category.group_id

                )" :key="index">
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                      }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      UTIPanels: "",
      UTIGroupId: "",
      selectedUTIPanels: [],
      loading: false,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      allTests: "",
      utiTestsPopup: false,
    };
  },
  mounted() {
    this.loading = true;
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;

    try {
      this.getSelectedGroupTitle()
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),


  },
  methods: {
    showUTITests() {
      this.utiTestsPopup = true;
    },
    getCategoryWiseTestsData(caseType, category, group_id) {
      return this.getNewLabGroupPanelTests.filter(
        (el) =>
          el.case_type_code == caseType &&
          el.panel_id == category &&
          el.group_id == group_id
      );
    },
    getCaseCategoryData() {
      let data = this.getNewLabGroupPanelTests.filter((e) =>
        this.UTIGroupId == e.group_id && this.selectedUTIPanels.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },
    getSelectedGroupTitle() {

      let selectedGroup = this.panelsTestsData.selectedGroup.filter((e)=>e.case_type_code =="UTI")
      
      if (selectedGroup.length) {
        const selectedGroupId = selectedGroup[0].group_id;
        
    
        const matchedGroup = this.getNewLabGroupWiseTests.find(
          (group) => group._id == selectedGroupId
        );

        this.UTIPanels = matchedGroup?.group_title || "No matching group";
        this.UTIGroupId = matchedGroup?.group_id

        if (matchedGroup?.panel_ids && matchedGroup?.panel_ids.length > 0 && typeof(matchedGroup?.panel_ids[0]) == "string"){
        this.selectedUTIPanels = matchedGroup?.panel_ids;
        } else {
          this.selectedUTIPanels = matchedGroup?.panel_ids.map((e)=>e._id)
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
#uti-panel-selected{
  .default-modal{
    .popup-panels-blocks{
      ul{
        .toxicology-text-panels{
          .check-list-woundpanel{
            li{
              .el-checkbox-group{
                .el-checkbox{
                    white-space: normal;
                    .el-checkbox__label{
                    line-height: 16px;
                    }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
